import { multiplyDecimals } from './components/utility'

// その他契約の税込表示の計算

document.querySelectorAll('input[name="royality"]').forEach((inputEl) => {
  inputEl.addEventListener('change', (e) => {
    document.querySelectorAll('.royality-with-tax').forEach((royalityEl) => {
      royalityEl.textContent = Math.round(multiplyDecimals(e.target.value, 1.1, 0, 1)).toLocaleString()
    })
  })
  inputEl.dispatchEvent(new Event('change'))
})
